import type { CoverSheetConfigCard } from '../../types';

export const emdCard = {
  id: 'earnestMoneyDeposit',
  innerTitle: 'Earnest Money Deposit',
  fields: {
    emdHolderCompanyName: {
      name: 'emdHolderCompanyName',
      entity: 'interaction',
      type: 'text',
      label: 'EMD Holder Company Name',
      placeholderText: '',
    },
    emdAmount: {
      name: 'emdAmount',
      entity: 'interaction',
      type: 'money',
      label: 'EMD Amount',
      placeholderText: '0.00',
    },
    numbersDaysEmdDue: {
      name: 'numbersDaysEmdDue',
      entity: 'interaction',
      type: 'number',
      label: 'Number of Days After Acceptance EMD is Due',
      placeholderText: '',
    },
  },
} satisfies CoverSheetConfigCard;
